import { ArrowRightOutlined } from '@ant-design/icons';
import { useAuth0 } from '@auth0/auth0-react';
import styles from '@styles/TryGoldButton.module.scss';
import cn from 'classnames';
import { useConfig } from 'providers';
import { FC, useMemo } from 'react';
import { useSubscription } from 'services/hooks/queries/useSubscription';
import { useTrial } from 'services/hooks/queries/useTrial';

type Props = {
  url?: string;
  icon?: boolean;
  text?: string | null;
  className?: string;
};

const TryGoldButton: FC<Props> = ({ icon = false, className }) => {
  const { mdcAccountUrl } = useConfig();

  const { isAuthenticated } = useAuth0();
  const { isSubscribed } = useSubscription();
  const { isTrialUser } = useTrial();

  const manageSubscriptionUrl = useMemo(() => `${mdcAccountUrl}/settings/subscription`, [mdcAccountUrl]);

  if (isTrialUser || isSubscribed) {
    return null;
  }

  if (!isAuthenticated) {
    return (
      <a href={manageSubscriptionUrl} className={cn(styles.button, className)}>
        Try Pro for Free {icon && <ArrowRightOutlined />}
      </a>
    );
  }

  return (
    <a href={manageSubscriptionUrl} className={cn(styles.button, className)}>
      Upgrade {icon && <ArrowRightOutlined />}
    </a>
  );
};

export default TryGoldButton;
